import { getAddress, type Address } from "viem";

export type VenueId = "morpho" | "ajna";

export type Venue = {
  readonly id: VenueId;
  readonly shortLabel: string;
  readonly longLabel: string;
  readonly tagline: string;
  /** Lending venue contract (Morpho Blue singleton, Ajna pool, etc.). */
  readonly contract: Address;
  /** Deployed looper contract for this venue. */
  readonly looper: Address;
  /** Block at which the looper contract was deployed — used as getLogs fromBlock. */
  readonly deployedAt: bigint;
  readonly href: string;
};

/** Morpho Blue singleton on Base. */
const MORPHO_BLUE_BASE: Address = getAddress(
  "0xbbbbbbbbbb9cc5e90e3b3af64bdaf62c37eeffcb",
);

/** Morpho Blue market id for CADC/USDC on Base. */
export const MORPHO_CADC_USDC_MARKET_ID =
  "0x6c8e2e253856bd9bbd3af99facd5ba907196ceb298100f4f7ef909921d2ad75e" as const;

/** MetaMorpho vault supplying USDC into the CADC/USDC market. */
export const MORPHO_CADC_USDC_VAULT: Address = getAddress(
  "0xf95c05dbc0ecaedbf5fc536f1d585aa964e36017",
);

export const VENUES: Record<VenueId, Venue> = {
  morpho: {
    id: "morpho",
    shortLabel: "Morpho",
    longLabel: "Morpho · CADC/USDC",
    tagline: "Deposit · Borrow",
    contract: MORPHO_BLUE_BASE,
    looper: getAddress("0x9FBdF021C7C2158993e13345721493034b6f6F3c"),
    deployedAt: 0x2d03f66n,
    href: `https://app.morpho.org/base/market/${MORPHO_CADC_USDC_MARKET_ID}/cadc-usdc`,
  },
  ajna: {
    id: "ajna",
    shortLabel: "Ajna",
    longLabel: "Ajna · CADC/USDC",
    tagline: "Deposit · Borrow",
    contract: getAddress("0x2a869a3911396ff387f4671735dc7df3330d0c31"),
    looper: getAddress("0x58e70df2e8ea9230BC2AFA30f88D6BD494F606e6"),
    deployedAt: 0x2d03ed0n,
    href: "https://ajna.arb.capital/base/pools/0x2a869a3911396ff387f4671735dc7df3330d0c31",
  },
} as const;

export const DEFAULT_VENUE: VenueId = "morpho";

/** Ajna PoolInfoUtils on Base — helper contract for derived pool reads. */
export const AJNA_POOL_INFO_UTILS: Address = getAddress(
  "0x97fa9b0909C238D170C1ab3B5c728A3a45BBEcBa",
);

export const AERODROME = {
  label: "Aerodrome · USDC→CADC",
  address: getAddress("0xcf77a3ba9a5ca399b7c97c74d54e5b1beb874e43"),
  href: "https://aerodrome.finance/swap?from=0x833589fcd6edb6e08f4c7c32d4f71b54bda02913&to=0x043eb4b75d0805c43d7c834902e335621983cf03&chain0=8453&chain1=8453",
} as const;
